<template>
    <div class="index-container">
        <keep-alive>
            <Header :canSubmit="getCanSubmit()" :handleSubmit="handleSubmit" />
        </keep-alive>
        <div class="send-warp">
            <div class="input-box">
                <input
                    type="text"
                    v-model="title"
                    maxlength="40"
                    placeholder="输入标题（选填）"
                    @focus="handleTitleFocus"
                />
                <span :class="{ 'red-color': title.length > 39 }"
                    >{{ title.length }}/40</span
                >
            </div>
            <div
                class="content-box"
                id="input"
                @focus="handleContentFocus"
            ></div>
        </div>
        <div class="content-footer">
            <div>
                <div class="emoji-icon" id="toggle-icon">
                    <!-- <img
                        src="@/assets/emoji-icon-keyboard.png"
                    /> -->
                    <img src="@/assets/emoji-icon.png" />
                </div>
                <div class="content-count">
                    <span :class="{ 'red-color': inputCount > 200 }">{{
                        getShowCount()
                    }}</span
                    >/200
                </div>
            </div>
        </div>

        <div id="emoji-list-wrap" class="emoji-list-wrap"></div>

        <label
            class="upload-label"
            for="upload"
            v-if="uploadStatus === UPLOADING_PROGRESS.NOT_UPLOAD"
        >
            <div class="upload-container">
                <div class="upload">
                    <img src="@/assets/upload.png" />
                    <span>上传图片</span>
                </div>
            </div>
        </label>
        <label
            class="upload-label"
            for="upload"
            v-if="uploadStatus === UPLOADING_PROGRESS.UPLOADED"
        >
            <div class="uploaded">
                <div class="reupload">
                    <img class="preview" :src="uploadImg" />
                    <div class="reset-upload" @click="resetUpload($event)">
                        <img src="@/assets/close.png" />
                    </div>
                </div>
            </div>
        </label>
        <label
            class="upload-label"
            v-if="uploadStatus === UPLOADING_PROGRESS.UPLOAD_FAILED"
            for="upload"
        >
            <div class="uploaded">
                <div class="reupload" style="background: #F8F9FB">
                    <img class="broken" src="@/assets/broken.png" />
                    <div class="reset-upload" @click="resetUpload($event)">
                        <img src="@/assets/close.png" />
                    </div>
                    <p class="upload-failed-text">上传失败</p>
                </div>
                <p class="failed-tip">仅支持PNG、JPG、GIF格式，且不超过4M</p>
            </div>
        </label>
        <input ref="file" type="file" id="upload" @change="chosePics($event)" />
        <div class="send-footer">
            声明：用户发表的所有言论等仅代表个人观点，与本网站立场无关，不对您构成任何投资建议。
        </div>
        <div v-if="isUploading" class="uploading">
            <img src="@/assets/icons/uploading.gif" />
            <p>上传中...</p>
        </div>
        <Toast v-if="showToast" :text="toastText"></Toast>
    </div>
</template>

<script type="text/ecmascript-6">
import { request } from '@/api/request'
import { mapState } from 'vuex'
import Header from './Header.vue'
import Toast from '@/components/toast.vue'
import RHEmoji from '@/components/rhEmoji/index.js'
const UPLOADING_PROGRESS = {
    NOT_UPLOAD: 0,
    UPLOADING: 1,
    UPLOADED: 2,
    UPLOAD_FAILED: 3
}

export default {
    components: { Header, Toast },
    data() {
        return {
            title: '',
            toastText: '帖子已提交，将在审核完毕后发布',
            showToast: false,
            showIconList: false,
            RHEmoji: null,
            inputCount: 0,
            uploadStatus: UPLOADING_PROGRESS.NOT_UPLOAD,
            isUploading: false,
            uploadImg: '',
            isSending: false,
            pic: null
        }
    },
    computed: {
        ...mapState(['userInfo', 'symbol', 'market', 'tabIndex', 'tabs']),
        ...mapState({
            tabs: state => state.common.tabs,
            tabIndex: state => state.common.tabIndex,
        }),
        UPLOADING_PROGRESS() {
            return UPLOADING_PROGRESS
        }
    },
    created() {
        this.createInit()
    },
    mounted() {
        console.log(typeof window.$)
        const options = {
            mode: 'mobile',
            input: {
                inputElement: 'input',
                defaultContent: ""
            },
            list: {
                iconElement: 'toggle-icon',
                wrapElement: 'emoji-list-wrap'
            },
        };
        this.RHEmoji = new RHEmoji(options)
        this.RHEmoji.toggleChange = this.toggleChange
        this.RHEmoji.onChange = this.handleOnChange
    },
    methods: {
        _toast(toastText, time = 3000) {
            this.toastText = toastText
            this.showToast = true
            setTimeout(() => {
                this.showToast = false
            }, time)
        },
        getShowCount() {
            return this.inputCount < 200
                ? this.inputCount
                : -(this.inputCount - 200)
        },
        async createInit() {
            if (this.$route.params.code) this.$store.commit('setSymbol', this.$route.params)
            else this.$store.commit('setSymbol', this.$route.query)
            let stockname = await this.getStockName()
            this.$store.commit('setStockName', stockname)
        },
        async chosePics(e) {
            this.isUploading = true
            const file = e.target.files[0]
            if(!file) {
                this.isUploading = false
                return
            }
            if(file.size / (1024 * 1024) > 4) {
                this.isUploading = false
                this.uploadStatus = UPLOADING_PROGRESS.UPLOAD_FAILED
                return
            }
            let formData = new FormData();
            formData.append("attachment", file);
            formData.append("bucket", 'ytx-upload')

            const data = await request.post({
                url: request.apis.file.uploadFile,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: formData
            })
            console.log(123, data)
            if (data) {
                this.uploadImg = data
                this.uploadStatus = UPLOADING_PROGRESS.UPLOADED
            } else {
                this.uploadStatus = UPLOADING_PROGRESS.NOT_UPLOAD
            }
            this.isUploading = false
        },
        resetUpload(e) {
            this.uploadStatus = UPLOADING_PROGRESS.NOT_UPLOAD
            e.preventDefault()
            this.$refs.file.value = ''
        },
        /**
         * 获取个股名称
         */
        async getStockName() {
            function marketTransform(val) {
                let keytmar = {
                    NASDAQ: 'NASDAQ',
                    nasdaq: 'NASDAQ',
                    NA: 'NASDAQ',
                    sh: 'sh',
                    SH: 'sh',
                    sz: 'sz',
                    SZ: 'sz',
                    HK: 'HKSE',
                    hk: 'HKSE',
                    hkse: 'HKSE',
                    AMEX: 'AMEX',
                    amex: 'amex',
                    AM: 'AMEX',
                    am: 'AMEX',
                    HKIDX: 'HKIDX',
                    hkidx: 'HKIDX'
                }
                return keytmar[val] || val
            }
            let market = marketTransform(this.$store.state.market)
            let symbol = this.$store.state.code
            if (this.$store.state.isIndex && this.$store.state.region === 'CN') market = market.toLowerCase()
            if (this.$store.state.region === 'HK') {
                symbol = symbol.length === 4 && /\d+/.test(symbol) ? '0' + symbol : symbol
            }
            let res = await request.get({
                url: request.apis.quote.getStockName,
                params: {
                    symbol,
                    market,
                    keyword: this.$store.state.code,
                }
            })
            if (res && res.length > 0) {
                return res[0].Name
            }
        },
        async handleSubmit() {
            const content = this.RHEmoji.getContent()
            if (!content || content.length === 0 || this.isSending) return
            const { symbol, market, title, userInfo } = this
            const params = {
                token: userInfo.token,
                serverId: userInfo.serverId,
                recommendation: 0,
                creatorType: 0,
                contentType: this.uploadImg ? 1 : 0,
                symbol,
                market,
                content,
                title,
                areas: [0],
                columnCodes: ['stock.bar'],
                medias: [{
                    address: this.uploadImg
                }]

            }
            this.isSending = true
            let res = await request.post({
                url: request.apis.stockBar.publish,
                params
            })
            if (res) {
                this._toast('帖子已提交，将在审核完毕后发布')
                this.title = ''
                this.RHEmoji.clear()
                this.tabs[this.tabIndex].list = []
                this.tabs[this.tabIndex].pageNo = 1
                setTimeout(() => {
                    this.isSending = false
                    this.$router.push(`/${market}/${symbol}.html`)
                }, 2000)
            }
        },
        getCanSubmit() {
            if (this.inputCount > 0 && this.inputCount < 200 && !this.isSending) {
                return true
            }
            return false
        },
        toggleChange() {
            this.showIconList = !this.showIconList
        },
        handleOnChange() {
            this.inputCount = this.RHEmoji.count
        },
        handleTitleFocus() {
            this.RHEmoji.closeEmojiList()
            this.RHEmoji.canToggle = false
        },
        handleContentFocus() {
            this.RHEmoji.canToggle = true
        }
    }
}
</script>

<style lang="stylus" scoped>
div
    box-sizing border-box

.red-color
    color #f43737

.send-warp
    width 100%
    height 145px
    padding 0 12px
    background #fff
    overflow-x hidden
    overflow-y scroll

    .input-box
        height 46px
        display flex
        justify-content space-between
        align-items center
        color #333
        border-bottom 1px solid #F5F5F5

        span
            font-size 15px
            font-weight 400
            color #999999
            line-height 22px

        input
            height 44px
            flex 1
            border none
            font-size 16px
            outline none

    .content-box
        font-size 16px
        margin-top 10px
        min-height 88px
        font-weight 400
        color #333333
        line-height 22px

        .rhemoji-emo-mobile
            width 20px
            height 20px

.send-footer
    font-size 12px
    font-weight 400
    color #BBBBBB
    line-height 18px
    padding 0 12px
    background #fff

.send-btn
    display flex
    height 36px
    justify-content center
    background #F43737
    border-radius 2px
    align-items center
    color #fff

    &.disable
        background #BDBDBD

.content-footer
    padding 12px 12px 0 12px
    background #fff

    >div
        display flex
        justify-content space-between
        align-items center
        border-bottom 1px solid #F5F5F5
        padding-bottom 12px

    .emoji-icon
        width 26px
        height 26px

        &>img
            width 26px
            height 26px

    .content-count
        font-size 15px
        font-weight 400
        color #999999
        line-height 22px

.emoji-list-wrap
    width 100%

.upload-container
    height 64px
    padding 12px
    background #ffffff

    .upload
        background #F8F9FB
        height 100%
        display flex
        justify-content center
        align-items center
        color #999
        font-size 16px

        span
            margin-left 4px

        img
            width 14px
            height 14px

.upload-label
    display block

#upload
    display none

.uploaded
    background #ffffff
    padding 12px
    display flex

    .reupload
        display inline-block
        position relative
        border-radius 2px
        width 92px
        height 92px

    .preview
        width 92px
        height 92px
        object-fit cover
    .broken
        width 52px
        height 45px
        margin-left 20px
        margin-top 12px
    .reset-upload
        position absolute
        width 22px
        height 22px
        text-align center
        padding-top 4px
        top 0
        right 0
        background rgba(0, 0, 0, 0.3)
        border-radius 0px 2px 0px 0px

        img
            width 12px
            height 12px
.uploading
    width 105px
    height 105px
    background rgba(0, 0, 0, 0.7)
    border-radius 12px
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    text-align center
    color #FFFFFF
    font-size 16px
    img
        width 40px
        height 40px
        margin-top 12px
    p
        margin-top 5px
.upload-failed-text
    color #999999
    font-size 14px
    margin-top 4px
    text-align center
.failed-tip
    color #E94041
    font-size 12px
    align-self flex-end
    margin-left 10px
</style>